module.exports = __webpack_public_path__ + "media/images/vp/icon.mail.red-cfccfc39f5eec12cbcbd2efeadd20d9a.svg";